import { Training } from '@precheckin/models/training/training.model';
import { TrainingCenter } from '@precheckin/models/training-center/training-center.model';
import { TrainingCenterConfiguration } from '@precheckin/models/training-center-configuration/training-center-configuration.model';

export interface IPreCheckinTrainingStateModel {
  isTrainingReady: boolean;
  trainingCenterConfiguration: TrainingCenterConfiguration;
  training: Training;
  currentTraining: Training;
  trainingCenter: TrainingCenter;
}

export const defaultTrainingState = {
  isTrainingReady: false,
  currentTraining: new Training(),
  training: new Training(),
  trainingCenterConfiguration: new TrainingCenterConfiguration(),
  trainingCenter: new TrainingCenter()
} as IPreCheckinTrainingStateModel;
